import { IconArrowForward } from '@capitalise/ui-design-system';
import ImageTitleDescription from 'components/ImageTitleDescription';
import Welcome from 'modules/Onboarding/components/Welcome';
import CreditProfileStar from 'assets/svgs/credit-profile.svg';
import GrowFundingGirl from 'assets/svgs/grow-funding-girl.svg';
import PlanStep from '../components/PlanStep';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';
import { PaymentOrigin } from '@capitalise/common';

export default ({
  completeOnboarding,
  goToRoute,
  redirectToPaymentFlow,
  shouldDisplayPlans,
  user,
}) => [
  {
    label: 'Welcome',
    lead: 'Working with your adviser on the Capitalise platform improves your likelihood of funding by <strong>4x</strong>.',
    title: 'A few steps to get started',
    component: Welcome,
    iconButton: null,
    nextButtonLabel: 'Continue to onboarding',
  },
  {
    lead: 'Protect your cash flow and reduce risk to your business by knowing and monitoring the financial stability of your customers or partners.',
    label: 'Credit check',
    title: `Check a company’s credit score`,
    component: ImageTitleDescription,
    hasPrevious: true,
    image: CreditProfileStar,
    iconButton: IconArrowForward,
  },
  ...(shouldDisplayPlans
    ? [
        {
          lead: 'Capitalise makes it easy to find, compare and select lenders who match your business profile.',
          label: 'Find funding',
          title: 'Find funding for your business',
          component: ImageTitleDescription,
          hasPrevious: true,
          image: GrowFundingGirl,
        },
        {
          key: 'compare-plans',
          lead: 'By upgrading your plan, you will gain access to your full Experian credit profile and the ability to credit check other companies.',
          nextButtonLabel: 'Go to Today page',
          nextButtonAction: () => {
            completeOnboarding();
            Analytics.track(AnalyticsEventCategory.onboard, AnalyticsEventAction.completed, {
              extraParams: { key: 'compare-plans' },
            });
            goToRoute('/business/today');
          },
          label: 'Plans',
          title: 'Upgrade your plan for your Full Experian Credit Profile',
          component: PlanStep,
          isLastStep: true,
          hasPrevious: true,
          iconButton: IconArrowForward,
          options: { user },
          skipButtonLabel: 'Compare plans',
          skipCallback: () => {
            completeOnboarding();
            redirectToPaymentFlow(PaymentOrigin.CREDIT_PROFILE);
          },
        },
      ]
    : [
        {
          lead: 'Capitalise makes it easy to find, compare and select lenders who match your business profile.',
          label: 'Find funding',
          title: 'Find funding for your business',
          component: ImageTitleDescription,
          hasPrevious: true,
          image: GrowFundingGirl,
          isLastStep: true,
          iconButton: IconArrowForward,
          nextButtonLabel: 'Go to Today page',
          nextButtonAction: () => {
            completeOnboarding();
            Analytics.track(AnalyticsEventCategory.onboard, AnalyticsEventAction.completed, {
              extraParams: { key: 'find-funding' },
            });
            goToRoute('/business/today');
          },
        },
      ]),
];
